import store from "@/store";
import { ROLES } from "@/config/permissions";

function guestGuard(to, from, next) {
  const user = store.state.users?.user || store.getters["users/currentUser"];
  const role =
    store.state.users?.role || store.getters["users/currentUserRole"];



  // If no user — allow access (guest only)
  if (!user || Object.keys(user).length === 0) {
    return next();
  }

  // If user is authenticated:

  if (role === ROLES.TEACHERS) {
    return next({ path: "/teacher-dashboard", replace: true });
  }
  if(role === ROLES.HOD || user.hod)
  {
    return next();
  }

  // Redirect based on role or data
  if (user.school) {
    return next({ path: "/", replace: true }); // or whatever your default user dashboard path is
  }

  if (role === ROLES.SYSTEMADMINS || user.role?.id === 1) {
    return next({ path: "/super-admin/schools", replace: true });
  }

  return next({ path: "/landing", replace: true });
}

export default guestGuard;
